/**
 * VisualizationUserEvents
 * Registry of events for the Visualization components
 */
export enum VisualizationUserEvents {
    ShowChartLegend = "Visualization - Show Chart Legend",
    HideChartLegend = "Visualization - Hide Chart Legend",
    ShowChartTimeframeNavigator = "Visualization - Show Chart Timeframe Navigator",
    HideChartTimeframeNavigator = "Visualization - Hide Chart Timeframe Navigator",
    ShowCumulativeChart = "Visualization - Show Cumulative Chart",
    ShowPercentOfTotalChart = "Visualization - Show Percent of Total Chart",
    ChangeTimeSeriesGroupBy = "Visualization - Change Time Series Group By",
    ChangeTimeSeriesAggregateFunction = "Visualization - Change Time Series Aggregate Function",
    ChangeTimeSeriesInterval = "Visualization - Change Time Series Interval",
    ChangeTimeSeriesSegment = "Visualization - Change Time Series Segment",
    ChangeVisualizationMode = "Visualization - Change Mode",
    TimeSeriesLoginCtaOpen = "Visualization - Time Series Login CTA Open",
    TimeSeriesLoginCtaClose = "Visualization - Time Series Login CTA Closed",
    TimeSeriesLoginCtaConfirmed = "Visualization - Time Series Login CTA Confirmed",
    ChangeMetricTimeseriesMetric = "Visualization - Change Metric Timeseries Metric",
}
